"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialSchema = exports.DigiRodeoCredentialSchema = exports.AngusCredentialSchema = exports.OptiWeighCredentialSchema = exports.CeresTagCredentialSchema = exports.PluginBusinessCredentialSchema = exports.PluginCredentialSchema = exports.PluginCredentialGenericSchema = void 0;
const zod_1 = require("zod");
const plugin_1 = require("../model/plugin");
exports.PluginCredentialGenericSchema = zod_1.z.object({
    pluginId: zod_1.z.string(),
    name: zod_1.z.string().optional(),
    status: zod_1.z.enum(["activated", "deactivated"]),
    activationDate: zod_1.z.date().optional(),
    deactivationDate: zod_1.z.date().nullable(),
    schedule: zod_1.z.string().optional(),
    lastTriggered: zod_1.z.date().nullable(),
});
exports.PluginCredentialSchema = zod_1.z.object({
    type: zod_1.z.literal(plugin_1.CredentialTypeSchema.enum.byservice)
}).merge(exports.PluginCredentialGenericSchema);
exports.PluginBusinessCredentialSchema = zod_1.z.object({
    type: zod_1.z.literal(plugin_1.CredentialTypeSchema.enum.bybusiness),
    keyId: zod_1.z.string()
}).merge(exports.PluginCredentialGenericSchema);
// export const PluginUserCredentialSchema = z.object({
//     pluginId: z.string(),
//     name: z.string().optional(),
//     type: z.literal("byusers"),
//     users: z.array(z.object({
//         userId: z.string(),
//         status: z.enum(["activated", "deactivated"]),
//         activationDate: z.date().optional(),
//         deactivationDate: z.date().nullable().optional(),
//         schedule: z.string().optional(),
//         lastTriggered: z.date().nullable().optional(),
//         keyId: z.string()
//     }))
// })
// export type PluginUserCredential = z.infer<typeof PluginUserCredentialSchema>
exports.CeresTagCredentialSchema = zod_1.z.object({
    clientId: zod_1.z.string(),
    clientSecret: zod_1.z.string()
});
exports.OptiWeighCredentialSchema = zod_1.z.object({
    clientId: zod_1.z.string(),
    apiKey: zod_1.z.string()
});
exports.AngusCredentialSchema = zod_1.z.object({
    memberId: zod_1.z.string(),
    username: zod_1.z.string(),
    password: zod_1.z.string()
});
exports.DigiRodeoCredentialSchema = zod_1.z.object({
    username: zod_1.z.string(),
    password: zod_1.z.string()
});
exports.CredentialSchema = zod_1.z.object({
    userId: zod_1.z.string().optional(),
    username: zod_1.z.string().optional(),
    password: zod_1.z.string().optional(),
    clientId: zod_1.z.string().optional(),
    clientSecret: zod_1.z.string().optional(),
    apiKey: zod_1.z.string().optional(),
    apiSecret: zod_1.z.string().optional(),
    memberId: zod_1.z.string().optional(),
});
